
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_13142_27223)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#282E3E"}},[_c('path',{attrs:{"d":"M7 4.492L5.892 7.498a.667.667 0 01-.395.395L2.492 9l3.005 1.108a.667.667 0 01.395.395L7 13.508l1.108-3.005a.667.667 0 01.395-.395L11.508 9 8.503 7.893a.667.667 0 01-.395-.395L7 4.492zm-.664-1.45a1.162 1.162 0 011.754.551l1.162 3.155 3.155 1.162a1.162 1.162 0 010 2.18l-3.155 1.162-1.162 3.155a1.163 1.163 0 01-2.18 0l-1.162-3.155-3.155-1.162a1.163 1.163 0 010-2.18l3.155-1.162L5.91 3.593c.082-.222.231-.415.426-.55zM11 .333c.368 0 .667.299.667.667v3a.667.667 0 01-1.334 0V1c0-.368.299-.667.667-.667zM14 3.833c.368 0 .667.299.667.667v2a.667.667 0 01-1.334 0v-2c0-.368.299-.667.667-.667z"}}),_c('path',{attrs:{"d":"M8.833 2.5c0-.368.299-.667.667-.667h3a.667.667 0 110 1.334h-3a.667.667 0 01-.667-.667zM12.333 5.5c0-.368.299-.667.667-.667h2a.667.667 0 110 1.334h-2a.667.667 0 01-.667-.667z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_13142_27223"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    